import React from "react";
// import { NextSeo } from "next-seo";
import TemplateSEO from "../TemplateSEO";

export default function BlogCategorySEO({ blogCategory }) {
    const title = `${blogCategory.name} blog category`;
    const description = blogCategory.description;
    const images = [{ url: blogCategory.category_image_file }];

    return (
        <>
            <TemplateSEO
                urlPath={`blog/categories/${blogCategory.slug}`}
                title={title}
                description={description}
                images={images}
            />
        </>
    );
}
